import { message } from 'antd';
import { EXPORT_SCOPE_KEYS, EXPORT_COPY } from './reports.constants';

/**
 * State management for the Reports export (KAN-548 / KAN-614). Composed into
 * `ReportsController` through `Inherit` next to `ReportsExportController` —
 * the same controller/delegate stacking as the Transactions tab.
 *
 * Nothing here talks to the data layer or sequences an outcome: the header
 * control's handler vets the request against what the screen shows and hands
 * it to the controller (`performExport`); the two setters are the only writers
 * of `state.exporting` / `state.exportJob`.
 */
class ReportsExportDelegate {
    /**
     * Header "Download" handler. One export at a time per screen: refused while
     * a request is in flight or an async job is still being polled (its
     * completion notification is the only copy of the download link, so it
     * must not be replaced silently). "By date range" needs a resolved range
     * on the active tab.
     * @param {string} scope one of EXPORT_SCOPE_KEYS
     */
    async requestExport(scope) {
        if (!Object.values(EXPORT_SCOPE_KEYS).includes(scope)) return;
        if (this.state?.exporting || this.state?.exportJob) {
            message.warning(EXPORT_COPY.ALREADY_PREPARING);
            return;
        }
        if (scope === EXPORT_SCOPE_KEYS.DATE && !this.hasActiveDateRange()) {
            message.warning(EXPORT_COPY.BY_DATE_DISABLED_TOOLTIP);
            return;
        }
        await this.performExport(scope);
    }

    /** `true` while the export request itself is in flight. */
    setExporting(isExporting) {
        this.setState({ exporting: Boolean(isExporting) });
    }

    /**
     * The async job being polled, or null.
     * @param {{ jobId: string, status: string, tab?: string, scope?: string, rowCount: number|null }|null} job
     */
    setExportJob(job) {
        this.setState({ exportJob: job ?? null });
    }
}

export default ReportsExportDelegate;
